import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/11_white_large-2/11_white_large-2"
 * Contains 12 texture(s)
 */
export class CardsFront11WhiteLarge2Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/11_white_large-2/11_white_large-2';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '7-spades.png',
        '7-hearts.png',
        '7-diamonds.png',
        '7-clubs.png',
        '6-spades.png',
        '6-hearts.png',
        '6-diamonds.png',
        '6-clubs.png',
        '5-spades.png',
        '5-hearts.png',
        '5-diamonds.png',
        '5-clubs.png'
    ] as const;
}
